export default __webpack_public_path__ + "static/screenshot8-b9f6bca304ba5f77765a7423c85179c3.jpg";